// Google Consent Mode v2 helpers

export const CONSENT_KEY = "mirexiluna_cookie_consent_v1";

export const DEFAULT_CONSENT = {
  necessary: true,
  analytics: false,
  ads: false,
  personalization: false,
};

export function readConsent() {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return { ...DEFAULT_CONSENT, ...parsed };
  } catch (e) {
    return null;
  }
}

export function saveConsent(consent) {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(
      CONSENT_KEY,
      JSON.stringify({ ...consent, ts: Date.now() })
    );
  } catch (e) {
    // ignore
  }
}

function gtag() {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

export function applyConsent(consent) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  const gt = function () {
    window.dataLayer.push(arguments);
  };
  gt("consent", "update", {
    ad_storage: consent.ads ? "granted" : "denied",
    ad_user_data: consent.ads ? "granted" : "denied",
    ad_personalization: consent.ads ? "granted" : "denied",
    analytics_storage: consent.analytics ? "granted" : "denied",
    personalization_storage: consent.personalization ? "granted" : "denied",
    functionality_storage: "granted",
    security_storage: "granted",
  });
  window.dataLayer.push({ event: "cookie_consent_update" });
}

export const ACCEPT_ALL = {
  necessary: true,
  analytics: true,
  ads: true,
  personalization: true,
};

export const REJECT_ALL = {
  necessary: true,
  analytics: false,
  ads: false,
  personalization: false,
};
